import React from "react";
import styled from "styled-components";
import { useApplicationStateValue } from "../../application/Application";
import TitleSeparator from "../../components/title-separator/TitleSeparator";
import { Box } from "reflexbox/styled-components";
import { Flex } from "reflexbox/styled-components";
import PanelHeader from "./panel-header/PanelHeader";
import PanelCodeInput from "../../components/panel-code-input/PanelCodeInput";
import { strings } from "../../languages/Localize";

const StyledDescription = styled(Box)`
    width: 100%;
    min-height: 10%;
    max-height: 60%;
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights.normal};
    word-wrap: break-word;
    padding: 2% 5%;
    overflow-y: auto;
`;

const StyledImpressionLabel = styled(Box)`
    height: 70%;
    width: 100%;
    font-size: ${({ theme }) => theme.fontSizes[5]}px;
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    color: ${({ theme }) => theme.colors.white};
`;

const StyledImpressionDescription = styled(Box)`
    height: 90%;
    width: 100%;
    word-wrap: break-word;
    font-size: ${({ theme }) => theme.fontSizes[2]}px;
    font-weight: ${({ theme }) => theme.fontWeights.light};
    line-height: 16px;
    color: ${({ theme }) => theme.colors.white};
    opacity: 0.8;
`;

const StyledImpressionLabelAndDescription = styled(Flex)`
    flex-direction: column;
`;

const StyledImpressionCode = styled(Box)`
    width: 80%;
    padding: 2%;
    text-align: end;
`;

const StyledImpression = styled(Flex)`
    flex-direction: row;
    padding: 2% 5%;
    align-items: center;
`;

const DivWithScrollY = styled(Flex)`
    overflow-y: auto;
    height: 90%;
    flex-direction: column;
`;

const Panel = ({
    match: {
        params: { id }
    }
}) => {
    const {
        appData: { forumPanels }
    } = useApplicationStateValue();

    return (
        <div style={{ height: "100%" }}>
            <TitleSeparator back>{strings.panel.HEADER}</TitleSeparator>
            <DivWithScrollY>
                <PanelHeader id={id} />
                <StyledDescription paddingX={[3, 4]} fontSize={[4]}>
                    {forumPanels[id].description}
                </StyledDescription>
                <StyledImpression paddingX={[3, 4]}>
                    <StyledImpressionLabelAndDescription>
                        <StyledImpressionLabel>{strings.panel.IMPRESSION}</StyledImpressionLabel>
                        <StyledImpressionDescription>
                            Molimo unesite kod koji je prikazan na ekranima tokom panela kako biste unijeli Vaš utisak ili postavili pitanje:
                        </StyledImpressionDescription>
                    </StyledImpressionLabelAndDescription>
                    {!forumPanels[id].impression?.comment && (
                        <StyledImpressionCode>
                            <PanelCodeInput impression={forumPanels[id].impression} code={forumPanels[id].code} id={id} />
                        </StyledImpressionCode>
                    )}
                </StyledImpression>
            </DivWithScrollY>
        </div>
    );
};

export default Panel;
